import type { ActionProps } from './types';

import { formatButtonTextWithCountdown } from '../../utils';

import { useCountdown } from '@/hooks/use-countdown';
import { useResolveVerification } from '@/hooks/use-resolve-verification';

export type RedirectActionProps = ActionProps & {
  label: string;
  payload: Record<string, string>;
  timeoutInSec?: number;
  url: string;
};

export const RedirectAction = ({ as: AsComponent, label, payload, timeoutInSec, url }: RedirectActionProps) => {
  const resolveFailedVerification = useResolveVerification({ url, payload });

  const { countdown } = useCountdown({
    onFinish: resolveFailedVerification,
    enabled: !!timeoutInSec,
    seconds: timeoutInSec,
  });

  return (
    <AsComponent onClick={resolveFailedVerification}>{formatButtonTextWithCountdown(label, countdown)}</AsComponent>
  );
};
